import leaseContractApi from '@/api/park/leaseContract';
export default {
  methods: {
    btnGroupHandler(clickName, params) {
      console.log(clickName, '按钮事件');
      this[clickName](params);
    },
    // 通过
    async passHandler() {
      let type = 1;
      this.$refs.approvalDialogRef.openDialog({ ...this.formData, type });
    },
    // 驳回
    async rejectHandler() {
      let type = 2;
      this.$refs.approvalDialogRef.openDialog({ ...this.formData, type });
    },
    // 保存
    async saveHandler() {
      this.saveOrSubmitHandler(0);
    },
    // 提交
    submitHandler() {
      this.saveOrSubmitHandler(1);
    },
    // 取消
    cancelHandler() {
      this.closeCurrentAndToList();
      const path = {
        path: '/park/leaseContract/leaseList',
        name: 'leaseList',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同管理',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },

    // 编辑
    editHandler() {
      // const path = {
      //   path: '/park/superviseContract/detail',
      //   name: 'detail',
      //   meta: {
      //     keepAlive: false,
      //     title: '监管合同维护',
      //   },
      //   query: {
      //     status: 'edit',
      //   },
      // };
      // this.$store.dispatch('tagsView/addTabView', path).then(() => {
      //   this.$nextTick(() => {
      //     this.$router.push(path);
      //   });
      // });
    },
    // 补充协议
    supplementAgreementHandler() {
      const path = {
        path: '/park/leaseContract/leaseContractAgreement',
        name: 'leaseContractAgreement',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同补充协议',
        },
        query: {
          status: 'editAgreement',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 续签
    renewHandler() {
      const path = {
        path: '/park/leaseContract/leaseContractRenew',
        name: 'leaseContractRenew',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同续签',
        },
        query: {
          status: 'renew',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 编辑协议
    editAgreementHandler() {
      // const path = {
      //   path: '/park/superviseContract/agreement',
      //   name: 'agreement',
      //   meta: {
      //     keepAlive: false,
      //     title: '补充协议',
      //   },
      //   query: {
      //     status: 'editAgreement',
      //     contractNo: this.$route.query.contractNo,
      //     id: this.$route.query.id,
      //   },
      // };
      // this.$store.dispatch('tagsView/addTabView', path).then(() => {
      //   this.$nextTick(() => {
      //     this.$router.push(path);
      //   });
      // });
    },
    // 保存协议
    saveAgreementHandler() {},
    // 关闭弹框
    closeHandler() {
      const { id, contractStatus } = this.formData;
      this.$refs.closeContractDialogRef.openDialog(id, contractStatus);
    },
    // 提交按钮
    // async passHandler() {
    //   // this.passOrRejectHandlerByNo('01');
    // },
    // 变更合同信息
    changeContractHandler() {
      const path = {
        path: '/park/leaseContract/leaseContractChange',
        name: 'leaseContractChange',
        meta: {
          keepAlive: false,
          title: '三方仓库租赁合同变更',
        },
        query: {
          status: 'change',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 变更主体
    changeHandler() {
      /**
       * 1.先走关闭合同逻辑
       * 2.走复制一份合同
       */
      this.closeHandler();
      this.changeRowData = {
        id: this.$route.query.id,
      };
    },
    // 删除
    deleteHandler() {
      const idList = [this.$route.query.id];
      this.$confirmAction('删除提示', '删除后将不可恢复，您确定要删除吗？')
        .then(async () => {
          const { data } = await this.$axios.post(`${leaseContractApi.DELETE_BY_ID}`, {
            ids: idList,
          });
          if (data.code == 0) {
            this.$message.success('删除成功');
            // 跳转到列表页面,并且关闭这个页面
            this.$store.dispatch('tagsView/delView', {
              path: '/leaseContract/leaseDetail',
              name: 'leaseDetail',
              meta: {
                keepAlive: false,
                title: '',
              },
              query: {},
            });
            this.$router.push('/park/leaseContract/leaseList');
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 提交审批
    async approvalHandler() {
      this.approvalOrRejectHandlerByNo('01');
    },
    // 保存或者提交 operateFlag 0保存,1提交，2撤销
    async saveOrSubmitHandler(operateFlag) {
      const postData = await this.getDetailData();
      const {
        data: { code, msg },
      } = await this.$axios.post(leaseContractApi.CREATE_CHANGE_RENEW, {
        ...postData,
        operateFlag,
      });
      if (code === 0) {
        this.$message.success(msg);
        this.$router.push('/park/leaseContract/leaseList');
      } else {
        this.$message.error(msg);
      }
    },
    // 审批通过或者驳回 01-通过,02-驳回
    async approvalOrRejectHandlerByNo(applovalResult) {
      const pageDetail = await this.getDetailData();
      // 通过原因
      const approvalComment = await this.$refs.approvalFormRef.getValidateFormData();
      const postData = {
        ...pageDetail, // 表单表格数据
        applovalResult,
        approvalComment,
        approvalContractType: '01',
        approvalDataNo: this.$route.query.contractNo,
      };
      const { data } = await this.$axios.post(leaseContractApi.APPROVAL_CONTRACT, postData);
      if (data.code == 0) {
        this.$message.success(data.msg);
        this.$router.push('/park/superviseContract/list');
      } else {
        this.$message.error(data.msg);
      }
    },
    // 获取页面表单表格数据
    async getDetailData() {
      // 1.表单数据
      const baseFormData = await this.$refs.baseInfoFormRef.getValidateFormData();
      console.log(baseFormData, '基础信息');
      // 2.空间信息
      console.log(
        'await this.$refs.spaceLinesRef.getValidateTableData()',
        await this.$refs.spaceLinesRef.getValidateTableData()
      );
      const { tableData: spaceLines, deleteSpaceLineIds } =
        await this.$refs.spaceLinesRef.getValidateTableData();
      spaceLines.forEach((item) => {
        item.expenseType = '00';
        item.expenseName = '租金';
      });
      console.log(spaceLines, '空间数据', deleteSpaceLineIds);
      // 3.其它费用数据
      const { tableData: expenseLines, deleteExpenseLineIds } =
        await this.$refs.expenseLinesRef.getValidateTableData();
      console.log(expenseLines, 'expenseLines', deleteExpenseLineIds);
      // 4.附件
      const attachments = this.$refs.fileTableRef.getTableData();
      const currentStatus = this.$route.query.status;
      const oldContractId = this.$route.query.id;

      const postData = {
        ...baseFormData,
        oldContractId: currentStatus == 'renew' ? oldContractId : '', // 单独处理续签的时候
        id: currentStatus == 'renew' ? '' : baseFormData.id, // 单独处理续签的时候
        spaceLines,
        deleteSpaceLineIds,
        expenseLines,
        deleteExpenseLineIds,
        attachments: attachments.map((item) => {
          return {
            ...item,
            // 特殊处理id
            id:
              ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                ? ''
                : item?.id,
          };
        }),
      };
      return postData;
    },
    closeCurrentAndToList() {
      this.$store.dispatch('tagsView/delView', {
        path: '/park/leaseContract/leaseDetail',
        name: 'leaseDetail',
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
    },
  },
};
